import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController } from 'ionic-angular';

/* Api */
import { ApiProvider } from '../../providers/api/api';

import { TranslateMsgProvider } from '../../providers/translate-msg/translate-msg';

import { LoginPage } from '../login/login';

@Component({
	selector: 'page-esqueceusenha',
	templateUrl: 'esqueceusenha.html',
})

export class EsqueceusenhaPage {

	email;
	codigo;
	senha;

	cliente;

	esqueceusenha = true;
	tenhocodigo = false;
	novasenha = false;

	constructor(public nav: NavController, private alertCtrl: AlertController, public _api: ApiProvider, public loadingCtrl: LoadingController, private _msg: TranslateMsgProvider) {}

    /* Verificar se o email é de algum cliente e enviar uma mensagem para recuperar a senha */
    recuperar()
    {
    	let loader = this.loadingCtrl.create({
            content: this._msg.getMsg('CARREGANDO')+"..."
        });
        loader.present();

    	this._api.enviaRecuperarSenha(this.email).subscribe(arg=>
    	{
    		// console.log(arg);
			loader.dismiss();
			if(arg.error == 1)
			{
				let alert = this.alertCtrl.create({
		            title: this._msg.getMsg('RECUPERACAO_SENHA_TITULO'),
		            subTitle: this._msg.getMsg('RECUPERACAO_SENHA_MSG1'),
		            buttons: [
		            {
		                text: 'OK'
		            }
		            ]
		        });
		        alert.present();
			}
			else if(arg.error == 2)
			{
				let alert = this.alertCtrl.create({
		            title: this._msg.getMsg('RECUPERACAO_SENHA_TITULO'),
		            subTitle: this._msg.getMsg('RECUPERACAO_SENHA_MSG2'),
		            buttons: [
		            {
		                text: 'OK'
		            }
		            ]
		        });
		        alert.present();
			}
			else
			{
		    	let alert = this.alertCtrl.create({
		            title: this._msg.getMsg('RECUPERACAO_SENHA_TITULO'),
		            subTitle: this._msg.getMsg('RECUPERACAO_SENHA_MSG3'),
		            buttons: [
		            {
		                text: 'OK',
		                handler: data => {
		                    this.tenhoCodigo();
		                }
		            }
		            ]
		        });
		        alert.present();
			}

    	});

    }

    /* Já tenho código de recuperação */
    tenhoCodigo()
    {
    	this.esqueceusenha = false;
		this.tenhocodigo = true;
    	return false;
    }

    /* Verifica se o código é válido */
    checkcodigo()
    {
    	let loader = this.loadingCtrl.create({
            content: this._msg.getMsg('CARREGANDO')+"..."
        });
        loader.present();

        this._api.recuperaSenhaCodigo(this.codigo).subscribe(arg=>{
        	// console.log(arg);
        	loader.dismiss();
        	if(arg == false)
        	{
        		let alert = this.alertCtrl.create({
		            title: this._msg.getMsg('RECUPERACAO_SENHA_TITULO'),
		            subTitle: this._msg.getMsg('RECUPERACAO_SENHA_MSG4'),
		            buttons: [
		            {
		                text: 'OK'
		            }
		            ]
		        });
		        alert.present();
        	}
        	else
        	{
        		this.cliente = arg;
				this.tenhocodigo = false;
				this.novasenha = true;
        	}
        });

    }

    /* Salvar nova senha */
    fazerNovaSenha()
    {
    	let loader = this.loadingCtrl.create({
            content: this._msg.getMsg('CARREGANDO')+"..."
        });
        loader.present();

    	this._api.alterarSenha(this.senha, this.cliente.id_cliente).subscribe(arg=>{
    		// console.log(arg);
        	loader.dismiss();
        	if(arg == 1)
        	{
		    	let alert = this.alertCtrl.create({
		            title: this._msg.getMsg('RECUPERACAO_SENHA_TITULO'),
		            subTitle: this._msg.getMsg('RECUPERACAO_SENHA_MSG5'),
		            buttons: [
		            {
		                text: 'OK',
		                handler: data => {
		                    this.nav.pop();
		                }
		            }
		            ]
		        });
		        alert.present();
        	}
        	else{
        		let alert = this.alertCtrl.create({
		            title: this._msg.getMsg('RECUPERACAO_SENHA_TITULO'),
		            subTitle: this._msg.getMsg('RECUPERACAO_SENHA_MSG6'),
		            buttons: [
		            {
		                text: 'OK'
		            }
		            ]
		        });
		        alert.present();
        	}
    	});
    }
}



// WEBPACK FOOTER //
// ./src/pages/esqueceusenha/esqueceusenha.ts